import instance from 'utils/apiCalls';
import { FEDERAL_STATE_URLS } from './FederalStateUrls';
import { FederalStateFormI, paramsI } from '../../../types/interface';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import { RootState } from 'redux/rootReducer';
import { federalStateSlice } from './FederalStateSlice';

const { actions } = federalStateSlice;

export const getFederalStates =
  (params?: paramsI) =>
  async (
    dispatch: ThunkDispatch<RootState[keyof RootState], unknown, Action>
  ) => {
    const response = await instance.get(FEDERAL_STATE_URLS.GET_FEDERAL_STATES, {
      params
    });
    dispatch(
      actions.setFederalStateTotalPages({
        totalPages: response?.data?.pagination?.totalPages,
        totalRecords: response?.data?.pagination?.totalRecords
      })
    );
    return response;
  };

export const getSingleFederalState = (id: number) => async () => {
  const response = await instance.get(
    FEDERAL_STATE_URLS.GET_SINGLE_FEDERAL_STATE.replace(':id', id?.toString())
  );
  return response;
};

export const createFederalState = (data: FederalStateFormI) => async () => {
  const response = await instance.post(
    FEDERAL_STATE_URLS.CREATE_FEDERAL_STATE,
    data
  );
  return response;
};

export const updateFederalState =
  (id: number, data: FederalStateFormI) => async () => {
    const response = await instance.put(
      FEDERAL_STATE_URLS.UPDATE_FEDERAL_STATE.replace(':id', id?.toString()),
      data
    );
    return response;
  };

export const deleteFederalState = (id: number) => async () => {
  const response = await instance.delete(
    FEDERAL_STATE_URLS.DELETE_FEDERAL_STATE.replace(':id', id?.toString())
  );
  return response;
};
